import {AiOutlineExclamationCircle} from "react-icons/ai";

import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";

export const AdvancedFeaturesWarning = () => (
  <div className="d-flex rounded rounded-3 p-2 px-4 border border-black align-items-center gap-4">
    <div>
      <AiOutlineExclamationCircle />
    </div>
    <div className="lh-base">
      We noticed you were trying some of our advanced features. Please note that{" "}
      <a href={`${URL_ORIGINAL_WEBSITE}/accounts/sso/saml/setup`} target="_blank">
        SSO
      </a>
      , Pagespeed Daily Check Frequency and{" "}
      <a href="/statuspages" target="_blank">
        Status Page Customization
      </a>{" "}
      are available starting from Essential plan, and 1-minute API Check Frequencies are available in Premium plan only.
      Please disable these features to subscribe to Starter or choose a higher level plan.
    </div>
  </div>
);
